/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgModifySubjectArea = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h6v2H4v4H2zm18 2h-4V2h6v6h-2zM6 6h12v5h-2V8H8v8h3v2H6zm11.293 6.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L16.414 22H12v-4.414zM14 18.414V20h1.586l4-4L18 14.414zM4 20v-4H2v6h6v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgModifySubjectArea as ModifySubjectArea };
